import { useUser } from '../index';
import { ENABLED_DETECT_PERMISSION } from '../../config';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { showToastInfo } from '../../@core/components/toastify/ToastTypes';
import Router from 'next/router';
import { USER_ROLES } from 'constants/constants';
export const useCheckPermission = (permissions, showAlert = true) => {
  const user = useUser();
  const { replace } = useRouter();
  function checkPermission() {
    if (ENABLED_DETECT_PERMISSION) {
      let hasPermission = false;
      if (Array.isArray(permissions)) {
        permissions?.map((item) => {
          if (
            user?.userType?.indexOf(
              item?.[2]
                ? `"method":"${item?.[0]?.toUpperCase()}","route":"${
                    item?.[1]
                  }","role":"${item?.[2]}"`
                : `"method":"${item?.[0]?.toUpperCase()}","route":"${
                    item?.[1]
                  }"`,
            ) !== -1
          ) {
            hasPermission = true;
          }
        });
      }
      return hasPermission;
    }
    return true;
  }

  useEffect(() => {
    const hasPermission = checkPermission();
    if (!hasPermission && showAlert) {
      replace('/401', '/');
      showToastInfo('You have no access to this Page');
      return Router.push('/');
    }
  }, [user?.userType]);
};

export const omitViewModes = (
  viewMode,
  options = { omitValues: [], addValues: [] },
) => {
  const { omitValues = [], addValues = [] } = options;
  let defaultOmitViews = new Set([
    USER_ROLES.LEARNER,
    USER_ROLES.CENTRE_ADMIN,
    ...addValues,
  ]);
  if (omitValues.length) {
    omitValues.map((mode) => defaultOmitViews.delete(mode));
  }
  return defaultOmitViews.has(viewMode);
};
